// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"86852ec6","420":"a7047c9e","453":"1fbcb3bf","457":"24d6579d","645":"9d03fef8","934":"7c2b2bba","962":"b0c799f6"}[chunkId] + ".chunk.js";
};